import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The Search No Result Component informs the user that no result has been found for his search and provides an input field for a new search.
 * It uses the {@link SearchBoxComponent}.
 *
 * @example
 * <ish-search-no-result
 *               [searchTerm]="searchTerm"
 * ></ish-search-no-result>
 */
@Component({
  selector: 'ish-search-no-result',
  templateUrl: './search-no-result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchNoResultComponent {
  /**
   * The search term leading to no result.
   */
  readonly searchTerm = input.required<string>();
}
